import React, {Component, Fragment} from 'react';
import Input from './Input';
import SubmitMsg from './SubmitMsg';
import Agent from './Agent';
import SocialIcons from './SocialIcons';

class Form extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isEnglish : true,
      disclaimerTitle : 'Disclaimer',
      disclaimer : this.props.disclaimer,
      // fields : {}
    };


    this.setInitialFormState = this.setInitialFormState.bind(this);
    this.setInitialMsgState = this.setInitialMsgState.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.resetState = this.resetState.bind(this);
    this.sendData = this.sendData.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.languageChange = this.languageChange.bind(this);
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
  }

  componentWillMount() {
    this.setInitialFormState();
    this.setInitialMsgState();
  }

  handleLanguageChange(){
    this.setState({
      isEnglish : !this.state.isEnglish
    },()=>{
      this.setInitialMsgState();
      this.languageChange();
    })
  }
  languageChange() {

    let field = this.state;
    if (this.props.handleLableChange) {
      let label = this.state.isEnglish ? 'Get in touch with us' :'Póngase en contacto con nosotros';
      this.props.handleLableChange(label);
    }
    if(!this.state.isEnglish){

      field["firstName"].label = "Nombre de pila ";
      field["firstName"].errormsg = "Se requiere el primer nombre!";
      field["lastName"].label = "Apellido ";
      field["lastName"].errormsg = "Se requiere el apellido!";
      field["email"].label = "Dirección de correo electrónico";
      field["email"].errormsg = "Se requiere un correo electrónico válido!";
      field["phone"].label = "Teléfono";
      field["phone"].errormsg = "Se requiere un número de teléfono válido!";
      field["maildesc"].label = "Comentarios";
      this.props.lpForm.heading = "Póngase en contacto con nosotros";
      field.disclaimerTitle = 'Disclaimer';
      field.disclaimer = this.props.disclaimer;
    }else{

      field["firstName"].label = "First Name";
      field["firstName"].errormsg="First Name is required!";
      field["lastName"].label = "Last Name ";
      field["lastName"].errormsg ="Last Name is required!";
      field["email"].label = "Email Address";
      field["email"].errormsg ="Valid Email is required!";
      field["phone"].label = "Phone";
      field["phone"].errormsg ="valid Phone Number is Required!";
      field["maildesc"].label = "Comments";
      this.props.lpForm.heading ="Get in touch with us";
      field.disclaimerTitle = 'Disclaimer';
      field.disclaimer = this.props.disclaimer;
    }

    // console.log(this.props);
    this.setState(field);
  }

  setInitialFormState() {
    let fields = {};
    if (this.props.frm.fields.length) {
        this.props.frm.fields.map(fld => {
        let field = {
          name: fld.name,
          label: fld.label,
          type: fld.type,
          value: fld.value,
          status: "initial",
          required: fld.required,
          pattern: fld.pattern,
          errormsg: fld.errormsg
        };
        //console.log(field);
        return (fields[fld.name] = field);
      });
    }

    this.setState(fields,()=>{
      //console.log(this.state["lastName"], this.state); 
    });

    // this.setState(fields);
  }

  setInitialMsgState() {
    let message = {};
    message["msg"] = {
      heading: "Form submitted successfully!",
      text:
          "Thanks for submitting your information. We will get back to you as soon as possible.",
      display: "none"
    };

    this.setState(message);
  }

  handleFormSubmit(e) {
    e.preventDefault();

    let result = this.validateForm(e);

    if (result) {
      let formData = {
        firstName: this.state["firstName"].value,
        lastName: this.state["lastName"].value,
        email: this.state["email"].value,
        phone: this.state["phone"].value,
        maildesc: this.state["maildesc"].value
      };
      this.props.lpForm.hidden_fields.map(
          field => (formData[field.name] = field.value)
      );
      this.sendData(formData);
      let msg = this.state.msg;

      if(!this.state.isEnglish){
        msg.autoClose = "Cierre automático en 4 segundos";
        msg.heading = "Formulario enviado correctamente!";
        msg.text = "Gracias por enviar su información. Nos pondremos en contacto con usted lo antes posible."
      }else{
        msg.autoClose = "Auto close in 4 seconds";
        msg.heading = "Form submitted successfully!";
        msg.text = "Thanks for submitting your information. We will get back to you as soon as possible."
      }

      msg.display = "block";
      this.setState(msg);
      // this.setInitialFormState();
      setTimeout(() => {
        this.setInitialMsgState();
      }, 4000);
    }
  }

  resetState() {
    let firstName = this.state["firstName"];
    firstName.value = "";
    firstName.status = "initial";
    this.setState(firstName);

    let lastName = this.state["lastName"];
    lastName.value = "";
    lastName.status = "initial";
    this.setState(lastName);

    let email = this.state["email"];
    email.value = "";
    email.status = "initial";
    this.setState(email);

    let phone = this.state["phone"];
    phone.value = "";
    phone.status = "initial";
    this.setState(phone);

    let maildesc = this.state["maildesc"];
    maildesc.value = "";
    maildesc.status = "initial";
    this.setState(maildesc);
  }

  sendData(formData) {
    let XHR = new XMLHttpRequest();
    let urlEncodedData = "";
    let urlEncodedDataPairs = [];
    let name;
    const that = this;

    for (name in formData) {
      urlEncodedDataPairs.push(
          encodeURIComponent(name) + "=" + encodeURIComponent(formData[name])
      );
    }

    urlEncodedData = urlEncodedDataPairs.join("&").replace(/%20/g, "+");

    XHR.addEventListener("load", function(event) {
      that.resetState();
    });

    XHR.addEventListener("error", function(event) {
      // alert('Oops! Something goes wrong.');
    });

    XHR.open("POST", formData["pu"]);

    XHR.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

    XHR.send(urlEncodedData);
  }

  validateForm(e) {
    let firstNameValid = true;
    let lastNameValid = true;
    let emailValid = true;
    let phoneValid = true;
    //console.log(phoneValid);

    if (this.state["firstName"].value === "") {
      let fieldObj = this.state["firstName"];
      fieldObj.status = false;
      firstNameValid = false;
      this.setState(fieldObj, function() {});
    } else {
      if (this.state["firstName"].pattern.test(this.state["firstName"].value)) {
        firstNameValid = true;
      } else {
        let fieldObj = this.state["firstName"];

        fieldObj.status = false;
        firstNameValid = false;
        this.setState(fieldObj, function() {});
      }
    }

    if (this.state["lastName"].value === "") {
      let fieldObj = this.state["lastName"];
      fieldObj.status = false;
      lastNameValid = false;
      this.setState(fieldObj, function() {});
    } else {
      if (this.state["lastName"].pattern.test(this.state["lastName"].value)) {
        lastNameValid = true;
      } else {
        let fieldObj = this.state["lastName"];

        fieldObj.status = false;
        lastNameValid = false;
        this.setState(fieldObj, function() {});
      }
    }
    if (this.state["email"].value === "") {
      let fieldObj = this.state["email"];
      fieldObj.status = false;
      emailValid = false;
      this.setState(fieldObj, function() {});
    } else {
      if (this.state["email"].pattern.test(this.state["email"].value)) {
        emailValid = true;
      } else {
        let fieldObj = this.state["email"];

        fieldObj.status = false;
        emailValid = false;
        this.setState(fieldObj, function() {});
      }
    }
    if (this.state["phone"].value === "") {
      let fieldObj = this.state["phone"];
      fieldObj.status = false;
      phoneValid = false;
      this.setState(fieldObj, function() {});
    } else {
      if (this.state["phone"].pattern.test(this.state["phone"].value)) {
        phoneValid = true;
      } else {
        let fieldObj = this.state["phone"];

        fieldObj.status = false;
        phoneValid = false;
        this.setState(fieldObj, function() {});
      }
    }
    if (firstNameValid && lastNameValid && emailValid) {
      return true;
    } else {
      return false;
    }
  }

  handleInputChange(event) {
    let fieldsObj = this.state[event.target.name];

    if (event.target.value) {
      if (event.target.name === "phone") {
        if (event.target.value.length === 15) {
          return false;
        }

        let prevLength = this.state[event.target.name].value.length;

        if (prevLength < event.target.value.length) {
          let res = event.target.value.replace(/\(/g, "");
          res = res.replace(/\)/g, "");
          res = res.replace(/-/g, "");
          res = res.replace(/\s/g, "");

          if (!parseInt(res, 0)) {
            return false;
          }
        }

        fieldsObj.value = event.target.value;

        let zeroChar = fieldsObj.value.charAt(0);
        if (zeroChar !== "(") {
          fieldsObj.value = "(" + fieldsObj.value;
        }

        let fourthChar = fieldsObj.value.charAt(4);

        if (parseInt(fourthChar, 0)) {
          let strOne = fieldsObj.value.substr(0, 4);
          let strTwo = fieldsObj.value.substr(4, fieldsObj.value.length - 1);
          fieldsObj.value = strOne + ")" + strTwo;
        }

        let fifthChar = fieldsObj.value.charAt(5);

        if (parseInt(fifthChar, 0)) {
          let strOne = fieldsObj.value.substr(0, 5);
          let strTwo = fieldsObj.value.substr(5, fieldsObj.value.length - 1);
          fieldsObj.value = strOne + " " + strTwo;
        }

        let eigthChar = fieldsObj.value.charAt(9);
        if (parseInt(eigthChar, 0)) {
          let strOne = fieldsObj.value.substr(0, 9);
          let strTwo = fieldsObj.value.substr(9, fieldsObj.value.length - 1);
          fieldsObj.value = strOne + "-" + strTwo;
        }

        fieldsObj.status = true;
        this.setState(fieldsObj, function() {
          // console.log(fieldsObj);
        });
      }

      if (event.target.name !== "phone") {
        fieldsObj.value = event.target.value;
        fieldsObj.status = true;
        this.setState(fieldsObj, function() {
          //console.log(fieldsObj);
        });
      }
    } else {
      let fieldsObj = this.state[event.target.name];
      fieldsObj.value = event.target.value;
      fieldsObj.status = false;
      this.setState(fieldsObj, function() {
        //console.log(fieldsObj);
      });
    }
  }
  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      disclaimer : nextProps.disclaimer
    })
  }

  render() {
    let cFormHead = null;
    let cForm = null;
    let cFormButton = null;
    let frmStyle = null;
    let submitMsg = null;
    let style = {};
    let buttonAlign = "right";
    let agentStyle = null;
    let finalOutput = null;
    let hiddenFields = null;
    let agentNameColor = "";
    let languageChanges = "";

    if (typeof this.props.styles.sidebar === "undefined") {
      style.backgroundColor = "transparent";
      style.color = "inherit";
      style.border = "1px solid #ddd";
    } else {
      style.backgroundColor = this.props.styles.sidebar.backgroundColor;
      style.color = this.props.styles.sidebar.color;
      style.border = "1px solid #ddd";
      if (
          this.props.template === "CROSSBAR" ||
          this.props.template === "CROSSBAR_FOOTER"
      )

      {
        let btnStyle = null;
        if (typeof this.props.styles["submit-btn"] !== "undefined") {
          btnStyle = {
            color: "white",
            border: "none",
            textAlign: "right",
            cursor: "pointer"


          };
        }
        languageChanges = (
            <a style={btnStyle}  onClick={this.handleLanguageChange}>
              {
                this.state.isEnglish ? 'Haga clic aquí para español' : 'Click here for English'
              }
            </a>
        );
        style.border = "1px solid " + this.props.styles.sidebar.backgroundColor;
      } else if (this.props.template === "CROSSBAR_LEFT") {
        style.border = "1px solid" + this.props.styles.sidebar.backgroundColor;
      }
    }

    if (
        this.props.template === "CROSSBAR_LEFT" ||
        this.props.template === "CROSSBAR_LEFT_FOOTER"
    ) {
      let btnStyle = null;
      if (typeof this.props.styles["submit-btn"] !== "undefined") {
        btnStyle = {
          color: "white",
          border: "none",
          textAlign: "right",
          cursor: "pointer"

        };
      }
      languageChanges = (
          <a style={btnStyle}  onClick={this.handleLanguageChange}>
            {
              this.state.isEnglish ? 'Haga clic aquí para español' : 'Click here for English'
            }
          </a>
      );
      agentStyle = {
        backgroundColor: "#6485C7",
        color: "#FFF",
        border: "1px solid #6485C7",
        position: "relative",
        top: "40%",
        paddingLeft: "10px",
        paddingRight: "10px"
      };
      if (this.props.styles.agentBox) {
        agentStyle.backgroundColor = this.props.styles.agentBox.backgroundColor;
        agentStyle.color = this.props.styles.agentBox.color;
        agentStyle.border =
            "1px solid " + this.props.styles.agentBox.backgroundColor;
      }

      if (this.props.styles.agentName) {
        agentNameColor = {
          color: this.props.styles.agentName.color
        };
      }

      if (this.props.template === "CROSSBAR_LEFT_FOOTER") {
        agentStyle.top = "0";
        let btnStyle = null;
        if (typeof this.props.styles["submit-btn"] !== "undefined") {
          btnStyle = {
            color: "white",
            border: "none",
            textAlign: "right",
            cursor: "pointer"

          };
        }
        languageChanges = (
            <a style={btnStyle}  onClick={this.handleLanguageChange}>
              {
                this.state.isEnglish ? 'Haga clic aquí para español' : 'Click here for English'
              }
            </a>
        );

      }
    }

    if (
        this.props.template === "GET_STARTED" ||
        this.props.template === "GET_STARTED_FOOTER"
    ) {
      let btnStyle = null;
      if (typeof this.props.styles["submit-btn"] !== "undefined") {
        btnStyle = {
          color: "white",
          border: "none",
          textAlign: "right",
          cursor: "pointer",
        };
      }

      languageChanges = (
          <a style= {btnStyle}   onClick={this.handleLanguageChange}>
            {
              this.state.isEnglish ? 'Haga clic aquí para español' : 'Click here for English'
            }
          </a>
      );

      cFormHead = null;
    } else {
      cFormHead =
          typeof this.props.lpForm !== "undefined" ? (
              <h5>{this.props.lpForm.heading}</h5>
          ) : (
              <h5>Contact Us</h5>
          );
    }

    if (this.props.frm.fields.length) {
      //code by anand
      if (
          this.props.template === "SOCIALIZE" ||
          this.props.template === "SOCIALIZE_FOOTER"
      ) {
        let btnStyle = null;
        if (typeof this.props.styles["submit-btn"] !== "undefined") {
          btnStyle = {
            backgroundColor: this.props.styles["submit-btn"].backgroundColor,
            color: "white",
            border: "none",
            textAlign: "right",


          };
        }
        cFormButton = (
            <Fragment>
              <Disclaimer text={this.state.disclaimer} title={this.state.disclaimerTitle}/>
              <div className="submit_button_block">
                <button
                    style={btnStyle}
                    type="submit"
                    className="btn btn-danger submit-btn"
                >
                  Submit
                </button>
              </div>
            </Fragment>
        );
      } else if (this.props.template === "CROSSBAR_FOOTER") {
        let btnStyle = {
          backgroundColor: this.props.styles["submit-btn"].backgroundColor,
          color: "white",
          border: "none",
          textAlign: "right"
        };
        cFormButton = (
            <div className="col-md-12 text-right ">
              <Disclaimer text={this.state.disclaimer} title={this.state.disclaimerTitle}/>
              <button
                  style={btnStyle}
                  type="submit"
                  className="btn btn-primary submit-btn"
              >
                Submit
              </button>
            </div>
        );
      } else {
        let btnStyle = null;
        if (typeof this.props.styles["submit-btn"] !== "undefined") {
          btnStyle = {
            backgroundColor: this.props.styles["submit-btn"].backgroundColor,
            color: "white",
            border: "none",
            textAlign: "right"
          };
        }
        cFormButton = (
            <Fragment>
              <Disclaimer text={this.state.disclaimer} title={this.state.disclaimerTitle}/>
              <button
                  style={btnStyle}
                  type="submit"
                  className="btn btn-primary submit-btn">
                Submit
              </button>
            </Fragment>
        );
      }
      //-end.
    }

    if (this.props.frm.fields.length) {
      if (
          this.props.template === "THEATER_CONTACT" ||
          this.props.template === "THEATER_CONTACT_FOOTER" ||
          this.props.template === "THEATER_360_FOOTER"
      ) {
        //cForm = <BottomForm data={this.state} frm={this.props.frm} handleInputChange={this.handleInputChange} />

        let btnStyle = null;
        if (typeof this.props.styles["submit-btn"] !== "undefined") {
          btnStyle = {
            color: "white",
            border: "none",
            textAlign: "right",
            cursor: "pointer",

          };
        }
        languageChanges = (
            <a style={btnStyle} onClick={this.handleLanguageChange}>
              {
                this.state.isEnglish ? 'Haga clic aquí para español' : 'Click here for English'
              }
            </a>

        );

        cForm = (
            <div className="row">
              <div className="col-sm-12 col-md-4">
                <Input
                    field={this.state["firstName"]}
                    fieldValue={this.state[this.props.frm.fields[0].name].value}
                    fieldStatus={this.state["firstName"].status}
                    value={this.state[this.props.frm.fields[0].name].value}
                    handleInputChange={this.handleInputChange}
                    checkTheme={this.props.backgroundImageVal}
                />
                <Input
                    field={this.state["lastName"]}
                    fieldValue={this.state[this.props.frm.fields[1].name].value}
                    fieldStatus={this.state["lastName"].status}
                    value={this.state[this.props.frm.fields[1].name].value}
                    handleInputChange={this.handleInputChange}
                    checkTheme={this.props.backgroundImageVal}
                />
              </div>
              <div className="col-sm-12 col-md-4">
                <Input
                    field={this.state["email"]}
                    fieldValue={this.state[this.props.frm.fields[2].name].value}
                    fieldStatus={this.state["email"].status}
                    value={this.state[this.props.frm.fields[2].name].value}
                    handleInputChange={this.handleInputChange}
                    checkTheme={this.props.backgroundImageVal}
                />
                <Input
                    field={this.state["phone"]}
                    fieldValue={this.state[this.props.frm.fields[3].name].value}
                    fieldStatus={this.state["phone"].status}
                    value={this.state[this.props.frm.fields[3].name].value}
                    handleInputChange={this.handleInputChange}
                    checkTheme={this.props.backgroundImageVal}
                />
              </div>
              <div className="col-sm-12 col-md-4">
                <Input
                    field={this.state["maildesc"]}
                    fieldValue={this.state[this.props.frm.fields[4].name].value}
                    fieldStatus={this.state["maildesc"].status}
                    value={this.state[this.props.frm.fields[4].name].value}
                    handleInputChange={this.handleInputChange}
                    checkTheme={this.props.backgroundImageVal}
                />
              </div>
            </div>
        );
      } else if (
          this.props.template === "SOCIALIZE" ||
          this.props.template === "SOCIALIZE_FOOTER"
      ) {
        //code by anand
        //cForm = <BottomForm data={this.state} frm={this.props.frm} handleInputChange={this.handleInputChange} />

        let btnStyle = null;
        if (typeof this.props.styles["submit-btn"] !== "undefined") {
          btnStyle = {
            color: "white",
            border: "none",
            textAlign: "right",
          };
        }

        languageChanges = (
            <a style={btnStyle} className="form_language_change" onClick={this.handleLanguageChange}>
              {
                this.state.isEnglish ? 'Haga clic aquí para español' : 'Click here for English'
              }
            </a>
        );
        cForm = (
            <div className="form-wrapper-style">
              <div className="col-md-12 col-sm-12 col-xs-10 form-input-div">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="fa fa-user" />
                  </span>
                  </div>
                  <Input
                      //field={this.props.frm.fields[0]}
                      field={this.state["firstName"]}
                      fieldValue={this.state[this.props.frm.fields[0].name].value}
                      fieldStatus={this.state["firstName"].status}
                      value={this.state[this.props.frm.fields[0].name].value}
                      handleInputChange={this.handleInputChange}
                      checkTheme={this.props.backgroundImageVal}
                  />
                </div>
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="fa fa-user" />
                  </span>
                  </div>
                  <Input
                      field={this.state["lastName"]}
                      fieldValue={this.state[this.props.frm.fields[1].name].value}
                      fieldStatus={this.state["lastName"].status}
                      value={this.state[this.props.frm.fields[1].name].value}
                      handleInputChange={this.handleInputChange}
                      checkTheme={this.props.backgroundImageVal}
                  />
                </div>
              </div>
              <div className="col-md-12 col-sm-12 col-xs-10 form-input-div">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="fa fa-envelope-o" />
                  </span>
                  </div>
                  <Input
                      field={this.state["email"]}
                      fieldValue={this.state[this.props.frm.fields[2].name].value}
                      fieldStatus={this.state["email"].status}
                      value={this.state[this.props.frm.fields[2].name].value}
                      handleInputChange={this.handleInputChange}
                      checkTheme={this.props.backgroundImageVal}
                  />
                </div>
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="fa fa-phone" />
                  </span>
                  </div>
                  <Input
                      field={this.state["phone"]}
                      fieldValue={this.state[this.props.frm.fields[3].name].value}
                      fieldStatus={this.state["phone"].status}
                      value={this.state[this.props.frm.fields[3].name].value}
                      handleInputChange={this.handleInputChange}
                      checkTheme={this.props.backgroundImageVal}
                  />
                </div>
              </div>
              <div className="col-md-12 col-sm-12 col-xs-10 form-input-div">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="fa fa-comment" />
                  </span>
                  </div>
                  <Input
                      field={this.state["maildesc"]}
                      fieldValue={this.state[this.props.frm.fields[4].name].value}
                      fieldStatus={this.state["maildesc"].status}
                      value={this.state[this.props.frm.fields[4].name].value}
                      handleInputChange={this.handleInputChange}
                      checkTheme={this.props.backgroundImageVal}
                  />
                </div>
              </div>
            </div>

        );

        //-end
      } else {
        cForm = (

            // <Input
            //   key={"field_" + index}
            //   field={formField}
            //   fieldValue={this.state[formField.name].value}
            //   fieldStatus={this.state[formField.name].status}
            //   value={this.state[formField.name].value}
            //   handleInputChange={this.handleInputChange}
            // />
            <div>
              <Input
                  //field={this.props.frm.fields[0]}
                  field={this.state["firstName"]}
                  fieldValue={this.state[this.props.frm.fields[0].name].value}
                  fieldStatus={this.state["firstName"].status}
                  value={this.state[this.props.frm.fields[0].name].value}
                  handleInputChange={this.handleInputChange}
                  checkTheme={this.props.backgroundImageVal}
              />
              <Input
                  field={this.state["lastName"]}
                  fieldValue={this.state[this.props.frm.fields[1].name].value}
                  fieldStatus={this.state["lastName"].status}
                  value={this.state[this.props.frm.fields[1].name].value}
                  handleInputChange={this.handleInputChange}
                  checkTheme={this.props.backgroundImageVal}
              />
              <Input
                  field={this.state["email"]}
                  fieldValue={this.state[this.props.frm.fields[2].name].value}
                  fieldStatus={this.state["email"].status}
                  value={this.state[this.props.frm.fields[2].name].value}
                  handleInputChange={this.handleInputChange}
                  checkTheme={this.props.backgroundImageVal}
              />
              <Input
                  field={this.state["phone"]}
                  fieldValue={this.state[this.props.frm.fields[3].name].value}
                  fieldStatus={this.state["phone"].status}
                  value={this.state[this.props.frm.fields[3].name].value}
                  handleInputChange={this.handleInputChange}
                  checkTheme={this.props.backgroundImageVal}
              />
              <Input
                  field={this.state["maildesc"]}
                  fieldValue={this.state[this.props.frm.fields[4].name].value}
                  fieldStatus={this.state["maildesc"].status}
                  value={this.state[this.props.frm.fields[4].name].value}
                  handleInputChange={this.handleInputChange}
                  checkTheme={this.props.backgroundImageVal}
              />
            </div>


        );
      }

      frmStyle = {
        backgroundColor: style.backgroundColor,
        color: style.color,
        border: style.border,
        paddingTop: "1.5rem",
        paddingBottom: "1.5rem",
        paddingLeft: "1rem",
        paddingRight: "1rem"
      };
      submitMsg = <SubmitMsg msg={this.state.msg} />;

      if (this.props.template === "CROSSBAR") {
        buttonAlign = "right";
      }
    }

    if (this.props.lpForm) {
      if (this.props.lpForm.hidden_fields.length) {
        hiddenFields = this.props.lpForm.hidden_fields.map((field, index) => {
          return (
              <input
                  key={"input" + index}
                  type="hidden"
                  name={field.name}
                  value={field.value}
              />
          );
        });
      }
    }

    if (this.props.template === "CROSSBAR_LEFT") {

      finalOutput = (
          <React.Fragment>
            <Agent
                template={this.props.template}
                styles={agentStyle}
                agentNameColor={agentNameColor}
                info={this.props.agent}
                preview={this.props.preview}
            />
            <div className="form-temp-25" style={frmStyle}>
              {cFormHead}
              <form onSubmit={this.handleFormSubmit} noValidate>
                {cForm}
                {languageChanges}
                {submitMsg}
                {hiddenFields}
                <div style={{ textAlign: buttonAlign }}>{cFormButton}</div>
              </form>
            </div>
          </React.Fragment>
      );
    } else if (this.props.template === "CROSSBAR_LEFT_FOOTER") {
      finalOutput = <React.Fragment>
        <div className="form-temp-25" style={frmStyle}>
          {cFormHead}
          <form onSubmit={this.handleFormSubmit} noValidate>
            {cForm}
            {languageChanges}
            {submitMsg}
            {hiddenFields}
            <div style={{ textAlign: buttonAlign }}>{cFormButton}</div>
          </form>
        </div>
      </React.Fragment>;
    } else if (this.props.template === "SIMPLE_FLICKS" ){
      let btnStyle = null;
      if (typeof this.props.styles["submit-btn"] !== "undefined") {
        btnStyle = {
          color: "white",
          border: "none",
          textAlign: "right",
          cursor: "pointer"

        };
      }
      languageChanges = (
          <a style={btnStyle}  onClick={this.handleLanguageChange}>
            {
              this.state.isEnglish ? 'Haga clic aquí para español' : 'Click here for English'
            }
          </a>
      );

      if (frmStyle) {
        frmStyle.border = "none"; //to remove border at bottom triangle.
      }

      const triagleColor1 = {
        borderRightColor: this.props.styles.triagle1.borderRightColor
      };

      const triagleColor2 = {
        borderLeftColor: this.props.styles.triagle2.borderLeftColor
      };

      cFormHead = null;
      finalOutput = (
          <div style={frmStyle}>
            {cFormHead}{" "}
            <SocialIcons
                template={this.props.template}
                dealerName={this.props.dealerName}
                shareurl={this.props.shareurl}
                checkTheme={this.props.backgroundImageVal}
            />
            <form onSubmit={this.handleFormSubmit} noValidate>
              {cForm}
              {languageChanges}
              {submitMsg}
              {hiddenFields}
              <div style={{ textAlign: buttonAlign }}>{cFormButton}</div>
            </form>
            <div className="triagle1" style={triagleColor1} />
            <div className="triagle2" style={triagleColor2} />
          </div>
      );
    }


    else if (
        this.props.template === "GET_STARTED" ||
        this.props.template === "GET_STARTED_FOOTER"
    ) {

      if (frmStyle) {
        frmStyle.border = "none"; //to remove border at bottom triangle.
      }

      const triagleColor1 = {
        borderRightColor: this.props.styles.triagle1.borderRightColor
      };

      const triagleColor2 = {
        borderLeftColor: this.props.styles.triagle2.borderLeftColor
      };

      cFormHead = null;
      finalOutput = (
          <div style={frmStyle}>
            {cFormHead}{" "}
            <SocialIcons
                template={this.props.template}
                dealerName={this.props.dealerName}
                shareurl={this.props.shareurl}
                checkTheme={this.props.backgroundImageVal}
            />
            <form onSubmit={this.handleFormSubmit} noValidate>
              {cForm}
              {languageChanges}
              {submitMsg}
              {hiddenFields}
              <div style={{ textAlign: buttonAlign }}>{cFormButton}</div>
            </form>
            <div className="triagle1" style={triagleColor1} />
            <div className="triagle2" style={triagleColor2} />
          </div>
      );
    } else if (
        this.props.template === "SOCIALIZE" ||
        this.props.template === "SOCIALIZE_FOOTER"
    ) {
      //code by anand
      finalOutput = (
          <div>
            <SocialIcons
                template={this.props.template}
                dealerName={this.props.dealerName}
                shareurl={this.props.shareurl}
                checkTheme={this.props.backgroundImageVal}
            />
            <form onSubmit={this.handleFormSubmit} noValidate>
              {cForm}
              {languageChanges}
              {submitMsg}
              {hiddenFields}
              <div style={{ textAlign: buttonAlign }}>{cFormButton}</div>
            </form>
          </div>
      );
      //--end
    } else if (
        this.props.template === "THEATER_CONTACT" ||
        this.props.template === "THEATER_CONTACT_FOOTER" ||
        this.props.template === "THEATER_360_FOOTER"
    ) {
      finalOutput = (
          <div style={frmStyle}>
            {cFormHead}
            <form onSubmit={this.handleFormSubmit} noValidate>
              {cForm}
              {languageChanges}
              {submitMsg}
              {hiddenFields}
              <div style={{ textAlign: buttonAlign }}>{cFormButton}</div>
            </form>
          </div>
      );
    } else if (this.props.template) {
      finalOutput = (
          <div style={frmStyle}>
            {cFormHead}
            <form onSubmit={this.handleFormSubmit} noValidate>
              {cForm}
              {languageChanges}
              {submitMsg}
              {hiddenFields}
              <div style={{ textAlign: buttonAlign }}>{cFormButton}</div>
            </form>
          </div>
      );
    }
    return finalOutput;
  }
}

class Disclaimer extends Component{
  constructor(props){
    super(props);
    this.state = {
      title : this.props.title,
      text : this.props.text
    };
    this.openDisclaimerModal = this.openDisclaimerModal.bind(this);
    this.closeDisclaimer = this.closeDisclaimer.bind(this);
  }
  openDisclaimerModal(e){
    /*===== script for modal ====*/
    /*if((!!navigator.platform) && (/iPad|iPhone|iPod/.test(navigator.platform))) document.body.classList.add("ios-device");*/
    /*===== end of script for modal ====*/
    /*===== script for popup =====*/
    document.body.addEventListener('click', this.closeDisclaimer);
    document.getElementById('disclaimerModal').style.display = 'block';
    document.getElementById('disclaimerModal').style.left = '0';
    document.getElementById('disclaimerModal').style.width = '350px';
    var rect = document.getElementById('disclaimerModal').getBoundingClientRect();
    if(window.innerWidth>400 && (window.innerWidth - rect.left) < 400){
      document.getElementById('disclaimerModal').style.left = -(400 - window.innerWidth + rect.left) + 'px';
    }else if(window.innerWidth<=400){
      document.getElementById('disclaimerModal').style.left = -(rect.left-50) + 'px';
      document.getElementById('disclaimerModal').style.width = (window.innerWidth - 100)+'px';
    }
      window.addEventListener('resize', this.closeDisclaimer)
    /*==== end of script for poopup =====*/
  }
  closeDisclaimer(e){
    /*===== script for modal ====*/
    /*document.body.classList.remove('ios-device');*/
    /*===== end of script for modal ====*/
    /*===== script for popup =====*/
    e.stopImmediatePropagation();
    document.getElementById('disclaimerModal').style.display = 'none';
    document.body.removeEventListener('click',this.closeDisclaimer);
    window.removeEventListener('resize',this.closeDisclaimer)
    /*==== end of script for poopup =====*/
  }
  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      title : nextProps.title,
      text : nextProps.text
    });
  }
  render(){
    if(this.props.text) {
      return (
          <Fragment>
            <h6 style={{display: 'inline', fontWeight: 400, fontSize:'13px', padding : '5px 15px',textDecoration : 'underline', cursor : 'pointer',position : 'relative'}} onClick={this.openDisclaimerModal}>
              <div className={'disclaimer-modal'} id={'disclaimerModal'} style={{display : 'none'}}>
                <span className={'disclaimer-close'} onClick={this.closeDisclaimer}>&times;</span>
                <h6 style={{color:'#000',textAlign : 'left', fontSize : '11px', wordBreak : 'break-all'}}>{this.props.text}</h6>
              </div>
              {this.state.title}</h6>
            {/*<h6 data-toggle="modal" data-target="#disclaimerModal" style={{display: 'inline', fontWeight: 400, fontSize:'13px', padding : '5px',textDecoration : 'underline', cursor : 'pointer',position : 'relative'}} onClick={this.openDisclaimerModal}>
              {this.state.title}
            </h6>*/}
            {/*=== uncomment the above code and comment previous code to get modal ===*/}
            <div className={'modal fade in'} id={'disclaimerModal'} role="dialog" aria-labelledby="disclaimerModal" aria-hidden="false" style={{color:'#000', textAlign : 'justify'}} >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">{this.state.title}</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeDisclaimer}>
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <p>{this.state.text}</p>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.closeDisclaimer}>Close</button>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>

      )
    }
    return (<Fragment>&nbsp;
    </Fragment>)
  }
}


export default Form;


// WEBPACK FOOTER //
// ./src/components/Form.js